'use strict';

import ngResource from 'angular-resource';

class EndUserService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/end_user/:id',
            { id: '@id' },
            {
                index :  { method: 'GET',      isArray: true  },
                show  :  { method: 'GET',      isArray: false },
                create:  { method: 'POST',     isArray: false },
                update:  { method: 'PUT',      isArray: false },
                destroy: { method: 'DELETE',   isArray: false }
            }
        );

        this.oem_api = $resource(
            '/api/oem/end_user/:id',
            { id: '@id' },
            {
                index:  { method: 'GET', isArray: true },
                update: { method: 'PUT', isArray: false }
            }
        )
    }
}

export default angular.module('leptonApp.EndUserService', ['ngResource'])
    .service('EndUserService', ['$resource', EndUserService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/end_user/end_user.service.js